import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "modalConfirm",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body w-100 mx-2" }
const _hoisted_8 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2 border-bottom" }
const _hoisted_9 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_10 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_11 = { class: "col-lg-12 text-break" }
const _hoisted_12 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2 border-bottom" }
const _hoisted_13 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_14 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_15 = { class: "col-lg-12 text-break" }
const _hoisted_16 = { class: "fw-bold text-center my-4" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_19 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import { PropType, ref } from 'vue'
import { useRouter } from 'vue-router'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import communityManagerServices from '@/services/community-managers.services'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Object,
    default: () => ({
      department_name: '',
      email: '',
    }),
  },
  reset: {
    type: Function as PropType<() => void | undefined>,
  },
  messageModalCompleted: {
    type: Function as PropType<any>,
  },
},
  setup(__props) {

const props = __props

const router = useRouter()



const loadingCreate = ref(false)

const onSubmit = async (): Promise<void> => {
  const { department_name, email } = props.data
  loadingCreate.value = true
  try {
    const response = await communityManagerServices.createAdministratorsApi({
      id: router.currentRoute.value.params?.id,
      data: { department_name, email, community_id: router.currentRoute.value.params?.id },
    })

    if (response.status === 200) {
      props?.reset()
      props.messageModalCompleted('')
      loadingCreate.value = false
      return
    }

    if (response?.response?.status === 400) {
      props.messageModalCompleted(response?.response?.data?.data[0]?.message_code)
      loadingCreate.value = false
      return
    }
    props.messageModalCompleted('ERROR')
  } catch (error) {
    props.messageModalCompleted('ERROR')
    loadingCreate.value = false
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('adminRegistration')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)('SB20belong')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(__props.data.department_name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('email')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(__props.data.email), 1)
              ])
            ]),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(translate)('ques')), 1),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  type: 'secondary',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(Button, {
                  title: _unref(translate)('signUp'),
                  onClick: onSubmit,
                  type: 'secondary',
                  loading: loadingCreate.value,
                  disabled: loadingCreate.value
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})